import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import {
    downloadFile,
    exportReport,
    organisationDetails,
    uploadFile
} from "../../util/ApiUtils";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import {SystemUpdateAltTwoTone} from "@material-ui/icons";
import {GreenButton, GreyButton, RedButton} from "../common/ButtonsConstants";
import * as OperationalApiUtils from "../../util/OperationModuleApiUtils";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
        padding: '30px',
    },
}));

class OrgChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            orgId: "",
            orgScope: "",
            uploadedFileName: "",
            uploadedFileId: null,
            uploadedFileBytes: null,
            organisation: null,
            uploadCalled: false,
        };
        this.export = this.export.bind(this);
        this.showModal = this.showModal.bind(this);
        this.onImageUpload = this.onImageUpload.bind(this);
        this.onFileRemove = this.onFileRemove.bind(this);
        this.fileUploadHandler = this.fileUploadHandler.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    orgId: response.id,
                    orgScope: response.scope,
                    organisation: response,
                    uploadedFileName: response.orgChartFilename,
                    uploadedFileId: response.uploadedFileId,
                    uploadedFileBytes: response.uploadedFileBytes,
                    uploadCalled: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    showModal() {
        this.setState({ show: true });
    }

    closeModal() {
        this.setState({
            show: false,
        });
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    export() {
        exportReport('/organisation/export/ORG_CHART');
    }

    onFileRemove() {
        console.log('this.state', this.state)
        OperationalApiUtils.deleteFile('/organisation/deleteFile', this.state.orgId, this.state.uploadedFileId).then(
            () => this.setState({
                uploadedFileId: null,
                uploadedFileName: null,
                uploadedFileBytes: null,
            })
        );
    }

    picBase64(encoded) {
        return "data:image/png;base64," + encoded;
    }

    onImageUpload(event) {
        console.log('event.target.files[0]', event.target.files[0]);
        this.setState({
            uploadedOrgChart: event.target.files[0],
        });
    }

    fileUploadHandler = () => {
        this.setState({
            uploadCalled: true,
        });
        console.log('this.state.uploadedOrgChart', this.state.uploadedOrgChart);
        if (this.state.uploadedOrgChart === undefined) {
            this.setState({
                uploadCalled: false,
            });
            NotificationManager.warning('Error', 'Please select a file', 5000);
        } else {
            let filename = this.state.uploadedOrgChart.name;
            console.log('filename', filename);
            let suffix = ".jpg";
            let suffix1 = ".JPG";
            let suffix2 = ".jpeg";
            let suffix3 = ".JPEG";
            let suffix4 = ".png";
            let suffix5 = ".PNG";
            let suffix6 = ".pdf";
            let suffix7 = ".PDF";
            if ((filename.indexOf(suffix, filename.length - suffix.length) === -1)
                && (filename.indexOf(suffix1, filename.length - suffix1.length) === -1)
                && (filename.indexOf(suffix2, filename.length - suffix2.length) === -1)
                && (filename.indexOf(suffix3, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix4, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix5, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix6, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix7, filename.length - suffix3.length) === -1)
            ) {
                this.setState({
                    uploadCalled: false,
                });
                NotificationManager.warning('Error', 'Supported files are .img, .imeg, .png and .pdf', 5000);
            } else {
                const callback = (status, res) => {
                    console.log("fileUploadHandler status " + status);
                    console.log("fileUploadHandler result " + res);
                    NotificationManager.success('Success', 'The Company Logo has been uploaded.', 5000);
                    this.setState({
                        selectedFile: null,
                    });
                    this.loadOrganisationDetails();
                };
                uploadFile("/organisation/orgChartUpload", null, this.state.uploadedOrgChart, callback);
            }
        }
    };
    render() {
        const { state } = this;
        const { classes } = this.props;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Paper className={classes.root}>
                <Typography component="h2" variant="h5">
                    ORGANISATIONAL CHART
                </Typography>
                <div style={{ marginTop: '30px' }}>
                    {false && <canvas id="imageCanvas"/>}
                    {
                        !state.uploadedFileId
                            ? <span>
                                <label>Please upload the Organisational Chart: </label><input type="file" id="imageLoader" name="imageLoader" onChange={this.onImageUpload}/>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.fileUploadHandler()}
                                    disabled={this.state.uploadCalled || isAuditor}
                                >
                                    Upload File
                                </Button>
                              </span>
                            : <React.Fragment>
                                <img src={this.picBase64(this.state.uploadedFileBytes)} width="100%"/>
                                <span style={{ textAlign: 'center' }}>
                                    <GreyButton style={{ marginRight: '20px', marginTop: '20px', marginLeft: '20px' }} onClick={() => downloadFile(state.uploadedFileId)}>DOWNLOAD</GreyButton>
                                    <RedButton style={{ marginRight: '20px', marginTop: '20px' }} onClick={this.onFileRemove}>REMOVE</RedButton>
                                </span>
                            </React.Fragment>
                    }
                </div>
            </Paper>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(OrgChart);
